import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { OauthService } from 'src/app/services/one-drive/oauth.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { Plant } from 'src/app/models/plant.model';
import { CloudIntegration } from 'src/app/models/cloud-integrations.model';


@Component({
  standalone: false,
  selector: 'app-cloud-storage',
  templateUrl: './cloud-storage.component.html',
  styleUrls: ['./cloud-storage.component.css']
})
export class CloudStorageComponent {
  loginDisplay = false;
  modalParams = [
    {
      name: "Display name",
      isMandatory: true,
      value: "",
      dataType: "text"
    },
  ]
  currentPage: number = 1
  data: CloudIntegration[] = []
  pageSize: number = 5
  totalPages: number = 1
  loopArray: number[] = []

  get values() {
    return {
      data: this.data,
      currentPage: this.currentPage,
      totalPages: this.totalPages,
      loadData: this.loadData,
      loopArray: this.loopArray
    }
  }


  constructor(private http: HttpClient,
    private cloudIntService: OauthService,
    public toastService: ToastService
  ) { }

  async loginPopup() {
    const sessionId = this.generateUUID();
    this.cloudIntService.startCloudIntegration({
      sessionId: sessionId,
      displayName: this.modalParams[0].value
    }).subscribe({
      next: (response) => {
        const authUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=da803fca-8bef-4be1-b9c2-d44c4fec3d3b&response_type=code&redirect_uri=${environment.microsoftRedirectUrl}&response_mode=query&scope=openid profile offline_access User.Read Files.ReadWrite.All&prompt=login&state=${sessionId}`;
        const popup = window.open(authUrl, "authPopup", "width=600,height=600");
      },
      error: (err) => { console.log(err) }
    })
  }

  ngOnInit() {
    window.addEventListener('message', (event) => {
      if (event.origin !== 'http://localhost:7202') return;

      if (event.data?.type === 'ms_auth_code') {
        this.toastService.showToast = true;
        this.toastService.toastText = "Cloud Integration has been added successfully"
        setTimeout(() => {
          this.toastService.showToast = false;
        }, 5000);
        this.loadData()
      }

      if (event.data?.type === 'popupClosed') {
      }
    });
    this.loadData();
  }

  disconnect(id: number, name: string) {
    this.cloudIntService.disconnectCloudIntegration(id).subscribe({
      next: (response) => {
        if (response.success == true) {
          this.toastService.showToast = true;
          this.toastService.toastText = "Cloud Integration: " + name + " has been disconnected successfully";
          setTimeout(() => {
            this.toastService.showToast = false;
          }, 5000);
          this.loadData();
        }
      },
      error: (err) => {
        this.toastService.showToast = true;
        this.toastService.isError = true;
        this.toastService.toastText = err;
        setTimeout(() => {
          this.toastService.showToast = false;
        }, 5000);
        console.log(err);
      }
    })
  }

  loadData() {
    this.cloudIntService.getAllCloudIntegrationPag(this.currentPage, this.pageSize)
      .subscribe({
        next: (result: any) => {
          this.data = result.items;
          this.totalPages = result.totalPages;
          this.updateLoopArray();
        }
      })
  }

  onPageChange(pageNumber: number) {
    this.currentPage = pageNumber;
    this.loadData();
  }

  generateUUID(): string {
    return crypto.randomUUID();
  }

  updateLoopArray() {
    this.loopArray = new Array(this.totalPages).fill(0).map((_, index) => index + 1);
  }
}
